import { UseGuardStepHook } from "../useGuardStep";
import { useFlowState } from "@rapid/hooks/useFlowState";
import { useCurrentWorkspace } from "@rapid/hooks/useCurrentWorkspace";
import { useWorkspaces } from "@rapid/queries/workspaceQueries";
import { useAuth } from "@rapid/contexts/AuthContext";
import { useLocation, useSearchParams } from "react-router-dom";

export const useGuardNoWorkspace: UseGuardStepHook = () => {
    const { currentWorkspace } = useCurrentWorkspace();
    const { initialLoadComplete, user } = useAuth();
    const { isFetched } = useWorkspaces();
    // Still initializing if: auth hasn't settled yet, or user is logged in but workspaces haven't loaded.
    // Unauthenticated users have isFetched=false forever (disabled query), so we must gate on user.
    const workspacesInitializing = !initialLoadComplete || (!!user && !isFetched);
    const { step, computeUrlPath } = useFlowState();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    if (workspacesInitializing) {
        return { loading: true, passThrough: true, errors: [], redirect: null };
    }

    const intendedPath = currentWorkspace?.url ? `/${currentWorkspace.url}` : "/";
    const shouldRedirect = !location.pathname.startsWith(intendedPath);
    const hasModalOpen = searchParams.get("open") !== null;

    if (hasModalOpen) {
        return { loading: false, step, passThrough: true, errors: [], redirect: null };
    }

    const redirectPath = shouldRedirect
        ? computeUrlPath({ workspaceUrl: currentWorkspace?.url }) + location.search
        : null;

    return {
        loading: false,
        step,
        passThrough: !shouldRedirect,
        errors: [],
        redirect: redirectPath
    };
};
